

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { BocciaturaPresidioTIM } from "src/app/models/dto/bocciaturaPresidioTIM.model";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "app-presidioTIM_rifiuta_pratica",
    templateUrl: "./dialog-presidioTIM_rifiuta_pratica.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogPresidioTIMRifiutaPratica implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected rifiutaPraticaForm: FormGroup;
    protected isRifiutandoPratica:boolean = false;
    protected fase:string;
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
    ) {
      this.pratica          = this.config.data.pratica;
      this.fase          = this.config.data.fase;
      this.rifiutaPraticaForm = this.formBuilder.group({
        noteRifiutoPratica:        [ null, [Validators.required]]
      });
      
    }
  
    ngOnInit(): void {
    }

   

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isRifiutandoPratica = true;
        let bocciatura: BocciaturaPresidioTIM = new BocciaturaPresidioTIM();
            bocciatura.noteBocciatura = this.rifiutaPraticaForm.value.noteRifiutoPratica;
        
        this.praticheService.presidioTIMRifiutaPratica(this.pratica.id, this.fase, bocciatura).subscribe( {
            next: (res) => {
              this.isRifiutandoPratica = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isRifiutandoPratica = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di bocciatura della pratica!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          }
        );
      
      } 
    }
  
  }